
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"17.199","height":"18.548"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 14297","opacity":".87","fill":"none","stroke":"#444","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10"}},[_c('path',{attrs:{"data-name":"Path 629","d":"M13.185.6H4.017A3.414 3.414 0 0 0 .601 4.016v6.921a3.414 3.414 0 0 0 3.416 3.416h3.146v3.6l3.6-3.6h2.427a3.414 3.414 0 0 0 3.411-3.416V4.016A3.414 3.414 0 0 0 13.185.6z","stroke-width":"1.2"}}),_c('path',{attrs:{"data-name":"Path 630","d":"M6.983 6.622a1.76 1.76 0 0 1-.448-1.348 1.769 1.769 0 0 1 1.167-1.348 1.94 1.94 0 0 1 1.977 0 1.752 1.752 0 0 1 .809.809 1.845 1.845 0 0 1-.453 1.977c-.9.719-1.438.9-1.438 1.8v.9","stroke-width":"1.2"}}),_c('path',{attrs:{"data-name":"Line 129","stroke-width":"1.5","d":"M8.6 11.027v.27"}})])])
          )
        }
      }
    